// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__PI1jS","inner":"Footer_inner__2PJJk","nextIcon":"Footer_nextIcon__2EhvO","innerLeft":"Footer_innerLeft__3xxqe"};